import { Reducer, useReducer } from 'react';

export const SET_SHOW_EXP_DATE = 'setShowExpDate';
export const SET_SHOW_CVV = 'setShowCvv';
const SET_SHOT_VALUE_PAN = 'setValuePan';
export const SET_IS_FOCUSED = 'setIsFocused';
export const IS_SHOW_SHORT_VALUE = 'isShowShortValue';

interface FieldValue {
    value?: string | number | boolean | null;
    [key: string]: unknown;
}

interface CardFieldsState {
    isShowExpDate: boolean;
    isShowCvv: boolean;
    isFocused: boolean;
    isShowShortValue: boolean;
}

type CardFieldsAction =
    | { type: typeof SET_SHOW_EXP_DATE; isShowExpDate: boolean }
    | { type: typeof SET_SHOW_CVV; isShowCvv: boolean }
    | { type: typeof SET_IS_FOCUSED; isFocused: boolean }
    | { type: typeof IS_SHOW_SHORT_VALUE; isShowShortValue: boolean }
    | { type: typeof SET_SHOT_VALUE_PAN; isShowShortValue: boolean };

const reducer: Reducer<CardFieldsState, CardFieldsAction> = (state, action) => {
    switch (action.type) {
        case SET_SHOW_EXP_DATE:
            return {
                ...state,
                isShowExpDate: action.isShowExpDate,
            };
        case SET_SHOW_CVV:
            return {
                ...state,
                isShowCvv: action.isShowCvv,
            };
        case SET_IS_FOCUSED:
            return {
                ...state,
                isFocused: action.isFocused,
            };
        case IS_SHOW_SHORT_VALUE:
        case SET_SHOT_VALUE_PAN:
            return {
                ...state,
                isShowShortValue: action.isShowShortValue,
            };
        default:
            return state;
    }
};

const hasValue = (field?: FieldValue | null): boolean => Boolean(field && Object.keys(field).length > 0);

export const useReducerCardFiled = (expiredDate?: FieldValue | null, cvv?: FieldValue | null, pan?: FieldValue | null) => {
    const [state, dispatch] = useReducer(reducer, {
        isShowExpDate: hasValue(expiredDate),
        isShowCvv: hasValue(cvv),
        isFocused: false,
        isShowShortValue: Boolean(pan?.value),
    });
    return [state, dispatch] as const;
};
